import React, { useState, useRef } from "react";
import "../styles/DeleteAccount.css";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  deleteAccount,
  userResendOtp,
  mailOtpVerification,
} from "../actions/usersActions";
import { useNavigate } from "react-router-dom";

export default function DeleteAccount({ userData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [number, setNumber] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [disableButtonResend, setDisableButtonResend] = useState(false);
  const [otp_time, setOtp_time] = useState();
  const [attempt, setAttempt] = useState(0);
  const otpFormikRef = useRef(null);

  const initialValuesSendOtp = {
    mobile: "",
  };

  const initialValuesVerifyOtp = {
    emailOTP: "",
  };

  const validationSchemaSendOtp = Yup.object().shape({
    mobile: Yup.string()
      .required("Number is required"),
  });

  const validationSchemaVerifyOtp = Yup.object().shape({
    emailOTP: Yup.string().required("OTP is required"),
  });

  const handleSendOtp = async (values, actions) => {
    const reSendOtpPayload = { mobile: values.mobile };
    setDisableButtonResend(true);
    try {
      const response = await dispatch(userResendOtp(reSendOtpPayload, attempt));
      if (response?.status === true) {
        // toast.success(response.message);
        setOtpSent(true);
        setOtp_time(response?.otp_time);
        setAttempt(1);
        setDisableButtonResend(false);
        setNumber(values.number);
        otpFormikRef.current?.resetForm();
      } else {
        // toast.error(response.message);
        setDisableButtonResend(false);
      }
    } catch (error) {
      toast.error("Please try again, something went wrong!");
      setDisableButtonResend(false);
    }
    actions.setSubmitting(false);
  };

  const handleVerifyOtp = async (values, actions) => {
    const payload = {
      number,
      email_verification: 1,
      otp: values.emailOTP,
      otp_time,
      attempt,
    };
    setDisableButton(true);
    try {
      const response = await dispatch(mailOtpVerification(payload));
      if (response?.status === true) {
        toast.success(response?.message);
        setTimeout(() => navigate('/login'), 2000);
        // handleDeleteAccount(response?.data?.id);
      } else {
        if (response.message === "Invalid OTP") {
          setAttempt((prev) => prev + 1);
        }
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error("Please try again, something went wrong!");
    }
    setDisableButton(false);
    actions.setSubmitting(false);
  };

  // const handleDeleteAccount = async (id) => {
  //   try {
  //     const response = await dispatch(deleteAccount({ user_id: id }));
  //     if (response?.status === true) {
  //       toast.success("Account deleted successfully");
  //       setTimeout(() => window.location.reload(), 2000);
  //     } else {
  //       toast.error(response.message);
  //     }
  //   } catch (error) {
  //     toast.error("Failed to delete account");
  //   }
  // };

  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-4">
        <div className="page_inner_content_box ">
          <div
            className={`container mt-5 deleteAccountContainer ${
              userData ? "pan-card-margin" : ""
            }`}
          >
            <div className="text-center mb-4 d-flex justify-content-center align-items-center gap-3">
              {/* <img src={logo} alt="Logo" className="deleteAccountLogo" /> */}
              <h5
                className="mb-4 main-heading-title text-center"
                style={{ fontSize: "40px" }}
              >
                Delete Account
              </h5>
            </div>

            <div className="deleteAccountForm">
              <Formik
                initialValues={initialValuesSendOtp}
                validationSchema={validationSchemaSendOtp}
                onSubmit={handleSendOtp}
              >
                {({ handleSubmit, errors, touched, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <Field name="mobile">
                        {({ field, form, meta }) => (
                          <input
                            {...field}
                            type="text"
                            className={`form-control ${
                              meta.touched && meta.error ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Mobile Number"
                            onChange={(e) =>
                              form.setFieldValue(
                                field.name,
                                e.target.value.toLowerCase()
                              )
                            }
                          />
                        )}
                      </Field>
                      {touched.mobile && errors.mobile && (
                        <div className="invalid-feedback">{errors.mobile}</div>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="form_button next_btn"
                      disabled={disableButtonResend || isSubmitting}
                    >
                      {disableButtonResend
                        ? "Sending..."
                        : attempt === 0
                        ? "Send OTP"
                        : "Resend OTP"}
                    </button>
                  </Form>
                )}
              </Formik>

              {otpSent && (
                <Formik
                  innerRef={otpFormikRef}
                  initialValues={initialValuesVerifyOtp}
                  validationSchema={validationSchemaVerifyOtp}
                  onSubmit={handleVerifyOtp}
                >
                  {({ handleSubmit, errors, touched, isSubmitting }) => (
                    <Form onSubmit={handleSubmit} className="mt-4">
                      <div className="mb-3">
                        <Field
                          name="emailOTP"
                          type="text"
                          className={`form-control ${
                            touched.emailOTP && errors.emailOTP
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Enter OTP"
                        />
                        {touched.emailOTP && errors.emailOTP && (
                          <div className="invalid-feedback">
                            {errors.emailOTP}
                          </div>
                        )}
                      </div>
                      <button
                        type="submit"
                        className="form_button next_btn"
                        disabled={disableButton || isSubmitting}
                      >
                        {disableButton ? "Processing..." : "Verify"}
                      </button>
                      <div className="mt-3 text-muted small text-center">
                        OTP is sent successfully to email id, please check your
                        email.
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
